export enum LOGISTICS_PERMISSIONS {
  LOGISTICS_VIEW = 'PROVIDER_LOGISTICVIEW',
  LOGISTICS_WRITE = 'PROVIDER_LOGISTICWRITE',
}
